const $DCprimaryColor: string = '#5f38f9'
const $DCsecondaryColor: string = '#374151'
const $DCSuccessColor: string = '#2dc58c'
const $DCWarningColor: string = '#f2bc16'
const $DCDangerColor: string = '#df3c4e'
const $DCInfoColor: string = '#478ffc'
const $DCLightColor: string = '#e5e7eb'
const $DCPinkLightColor: string = '#fde9f1'
const $DCPinkColor: string = '#f24a8b'
const $DCprimaryLightColor: string = '#d6e4ff'
const $DCsecondaryLightColor: string = '#e7e8ea'
const $DCSuccessLightColor: string = '#d1fae5'
const $DCWarningLightColor: string = '#fdf7e3'
const $DCDangerLightColor: string = '#fce8e8'
const $DCInfoLightColor: string = '#d6e4ff'
const $DCLightestColor: string = '#f3f4f6'
const $DCprimaryShadowColor: string = 'rgba(95, 56, 249, .2);'
const $DCprimaryActiveColor: string = '#4c2dc7'
const $DCsecondaryActiveColor: string = '#2c3441'
const $DCSuccessActiveColor: string = '#249e70'
const $DCWarningActiveColor: string = '#f5c945'
const $DCDangerActiveColor: string = '#b2303e'
const $DCInfoActiveColor: string = '#3972ca'
const $DCLightActiveColor: string = '#b7b9bc'
const $secondaryColor: string = '#db01f9'
const $textColor: string = '#171717'
const $standardFontSize: string = '16px'
const $headingFontSize: string = '23px'
const $infoFontSize: string = '14px'

const $default_primary = '#9b02fd'
const $red_accent = '#ff5252'
const $red_primary = '#f44336'
const $red_secondary = '#d32f2f'
const $red_warm = '#c62828'
const $pink_accent = '#ff4081'
const $pink_primary = '#e91e63'
const $pink_secondary = '#c2185b'
const $pink_warm = '#ad1457'
const $purple_accent = '#e040fb'
const $purple_primary = '#9c27b0'
const $purple_secondary = '#7b1fa2'
const $purple_warm = '#6a1b9a'
const $deep_purple_accent = '#7c4dff'
const $deep_purple_primary = '#9b02fd'
const $deep_purple_secondary = '#512da8'
const $deep_purple_warm = '#4527a0'
const $indigo_accent = '#536dfe'
const $indigo_primary = '#3f51b5'
const $indigo_secondary = '#303f9f'
const $indigo_warm = '#283593'
const $blue_accent = '#448aff'
const $blue_primary = '#2196f3'
const $blue_secondary = '#1976d2'
const $blue_warm = '#1565c0'
const $light_blue_accent = '#40c4ff'
const $light_blue_primary = '#03a9f4'
const $light_blue_secondary = '#0288d1'
const $light_blue_warm = '#0277bd'
const $cyan_accent = '#18ffff'
const $cyan_primary = '#00bcd4'
const $cyan_secondary = '#0097a7'
const $cyan_warm = '#00838f'
const $teal_accent = '#64ffda'
const $teal_primary = '#009688'
const $teal_secondary = '#00796b'
const $teal_warm = '#00695c'
const $green_accent = '#69f0ae'
const $green_primary = '#4caf50'
const $green_secondary = '#388e3c'
const $green_warm = '#2e7d32'
const $light_green_accent = '#b2ff59'
const $light_green_primary = '#8bc34a'
const $light_green_secondary = '#689f38'
const $light_green_warm = '#558b2f'
const $lime_accent = '#eeff41'
const $lime_primary = '#cddc39'
const $lime_secondary = '#afb42b'
const $lime_warm = '#9e9d24'
const $yellow_accent = '#ffff00'
const $yellow_primary = '#ffeb3b'
const $yellow_secondary = '#fbc02d'
const $yellow_warm = '#f9a825'
const $amber_accent = '#ffd740'
const $amber_primary = '#ffc107'
const $amber_secondary = '#ffa000'
const $amber_warm = '#ff8f00'
const $orange_accent = '#ffab40'
const $orange_primary = '#ff9800'
const $orange_secondary = '#f57c00'
const $orange_warm = '#ef6c00'
const $deep_orange_accent = '#ff6e40'
const $deep_orange_primary = '#ff5722'
const $deep_orange_secondary = '#e64a19'
const $deep_orange_warm = '#d84315'
const $brown_accent = '#bcaaa4'
const $brown_primary = '#795548'
const $brown_secondary = '#5d4037'
const $brown_warm = '#4e342e'
const $grey_accent = '#e9e9e9'
const $grey_primary = '#9e9e9e'
const $grey_secondary = '#616161'
const $grey_warm = '#424242'
const $blue_grey_accent = '#b0bec5'
const $blue_grey_primary = '#9e9e9e'
const $blue_grey_secondary = '#616161'
const $blue_grey_warm = '#424242'

interface Theme {
  primary: string
  secondary: string
}

// Theme object for dynamic theme changes
const theme = {
  primary: $DCprimaryColor,
  secondary: $secondaryColor,
}

const changeTheme = (ThemeColors: Theme) => {
  theme.primary = ThemeColors.primary
  theme.secondary = ThemeColors.secondary
}

const addAlpha = (color: string, opacity: number) => {
  const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255)
  return color + _opacity.toString(16).toUpperCase()
}

const $primaryWithAlpha = (op: string) => addAlpha(theme.primary, Number(op))

const $secondaryWithAlpha = (op: string) =>
  addAlpha(theme.secondary, Number(op))

const $textColorWithAlpha = (op: string) => addAlpha($textColor, Number(op))

export {
  changeTheme,
  $DCPinkLightColor,
  $DCPinkColor,
  $DCprimaryLightColor,
  $DCsecondaryLightColor,
  $DCSuccessLightColor,
  $DCWarningLightColor,
  $DCDangerLightColor,
  $DCInfoLightColor,
  $DCLightestColor,
  $DCprimaryColor,
  $DCprimaryShadowColor,
  $DCsecondaryColor,
  $DCSuccessColor,
  $DCWarningColor,
  $DCDangerColor,
  $DCInfoColor,
  $DCLightColor,
  $DCSuccessActiveColor,
  $DCWarningActiveColor,
  $DCDangerActiveColor,
  $DCInfoActiveColor,
  $DCLightActiveColor,
  $DCprimaryActiveColor,
  $DCsecondaryActiveColor,
  $secondaryColor,
  $primaryWithAlpha,
  $secondaryWithAlpha,
  $textColor,
  $textColorWithAlpha,
  $standardFontSize,
  $headingFontSize,
  $infoFontSize,
  $default_primary,
  $red_accent,
  $red_primary,
  $red_secondary,
  $red_warm,
  $pink_accent,
  $pink_primary,
  $pink_secondary,
  $pink_warm,
  $purple_accent,
  $purple_primary,
  $purple_secondary,
  $purple_warm,
  $deep_purple_accent,
  $deep_purple_primary,
  $deep_purple_secondary,
  $deep_purple_warm,
  $indigo_accent,
  $indigo_primary,
  $indigo_secondary,
  $indigo_warm,
  $blue_accent,
  $blue_primary,
  $blue_secondary,
  $blue_warm,
  $light_blue_accent,
  $light_blue_primary,
  $light_blue_secondary,
  $light_blue_warm,
  $cyan_accent,
  $cyan_primary,
  $cyan_secondary,
  $cyan_warm,
  $teal_accent,
  $teal_primary,
  $teal_secondary,
  $teal_warm,
  $green_accent,
  $green_primary,
  $green_secondary,
  $green_warm,
  $light_green_accent,
  $light_green_primary,
  $light_green_secondary,
  $light_green_warm,
  $lime_accent,
  $lime_primary,
  $lime_secondary,
  $lime_warm,
  $yellow_accent,
  $yellow_primary,
  $yellow_secondary,
  $yellow_warm,
  $amber_accent,
  $amber_primary,
  $amber_secondary,
  $amber_warm,
  $orange_accent,
  $orange_primary,
  $orange_secondary,
  $orange_warm,
  $deep_orange_accent,
  $deep_orange_primary,
  $deep_orange_secondary,
  $deep_orange_warm,
  $brown_accent,
  $brown_primary,
  $brown_secondary,
  $brown_warm,
  $grey_accent,
  $grey_primary,
  $grey_secondary,
  $grey_warm,
  $blue_grey_accent,
  $blue_grey_primary,
  $blue_grey_secondary,
  $blue_grey_warm,
}

export const colors = {
  primaryGradient: 'linear-gradient(to right, #2563eb, #9333ea)',
  primaryGradient2: 'linear-gradient(to right, #7d9bcb, #1d0a49)',
  primaryGradient3: 'linear-gradient(to right, #2563eb, #9333ea)',
  primary: $DCprimaryColor,
  secondary: $DCsecondaryColor,
  success: $DCSuccessColor,
  warning: $DCWarningColor,
  danger: $DCDangerColor,
  info: $DCInfoColor,
  light: $DCLightColor,
  pinkLight: $DCPinkLightColor,
  pink: $DCPinkColor,
  primaryLight: $DCprimaryLightColor,
  secondaryLight: $DCsecondaryLightColor,
  successLight: $DCSuccessLightColor,
  warningLight: $DCWarningLightColor,
  dangerLight: $DCDangerLightColor,
  infoLight: $DCInfoLightColor,
  lightest: $DCLightestColor,
  primaryActive: $DCprimaryActiveColor,
  secondaryActive: $DCsecondaryActiveColor,
  successActive: $DCSuccessActiveColor,
  warningActive: $DCWarningActiveColor,
  dangerActive: $DCDangerActiveColor,
  infoActive: $DCInfoActiveColor,
  lightActive: $DCLightActiveColor,
  secondaryAccent: $secondaryColor,
  text: $textColor,
  authBg: '#1b0c44',
  blueDark: '#1328a0',
  grayMedium: '#949fb1',
  grayDark: '#242d3e',
  grayDarker: '#1f2937',
  grayBorder: '#d1d5db',
  grayBorderDark: '#4b5563',
  grayBorderLight: '#e9ecef',
  white: '#fff',
  black: '#000',
  grayLightest: '#f7f7f7',
  grayLighter: '#efefef',
  grayShadow: '#d2d4e4',
  green: '#4CAF50',
  orange: '#FF9800',
  blue: '#2196F3',
  grayLabel: '#666',
  grayInput: '#dee2e6',
  grayInputDark: '#43476b',
  grayInputLight: '#d1d5db',
  grayInputBorder: '#d2d4e4',
  purple: $purple_primary,
  yellow: $yellow_primary,
  red: $red_primary,
  teal: $teal_primary,
  // Additional colors found in codebase
  grayLight: '#e5e5e5',
  grayMediumLight: '#e6e6e6',
  grayMediumDark: '#8e959b',
  grayMediumDarker: '#8e959c',
  grayVeryLight: '#f6f6f6',
  grayVeryLighter: '#fafafa',
  grayBorderMedium: '#e0e0e0',
  grayBorderLightest: '#eee',
  grayText: '#666',
  grayTextDark: '#333',
  grayTextLight: '#787C9E',
  grayTextLighter: '#A1A3B5',
  grayTextMedium: '#666',
  blueLight: '#136acd',
  blueLighter: '#00aeef',
  blueVeryLight: '#edf4ff',
  blueVeryLighter: '#E3F2FD',
  blueBorder: '#79c7ff',
  redLight: '#ff0000',
  redLighter: '#f53c36',
  redWarm: '#c62828',
  greenLight: '#0ad10e',
  greenLighter: '#4CAF50',
  orangeLight: '#FFC107',
  orangeLighter: '#F44336',
  purpleLight: '#9B02FD',
  purpleLighter: '#080885',
  yellowLight: '#f2bc16',
  yellowLighter: '#fdf7e3',
  redLightBg: '#fbe8ea',
  redLighterBg: '#fce8e8',
  yellowLightBg: '#fdf7e3',
  yellowLighterBg: '#fcf2d0',
  blueLightBg: '#f0f4fa',
  blueLighterBg: '#dae9fe',
  greenLightBg: '#d5f3e8',
  greenLighterBg: '#abe8d1',
  grayLightBg: '#f7f7f7',
  grayLighterBg: '#f8f9fa',
  grayVeryLightBg: '#e9ecef',
  grayVeryLighterBg: '#e9ecef78',
  grayBorderBg: '#d4d4d4',
  grayBorderLightBg: '#ced4da',
  grayBorderLighterBg: '#dbe2e9',
  grayBorderLightestBg: '#c4c8cb',
  grayBorderMediumBg: '#adb5bd',
  grayBorderDarkBg: '#9cf',
  grayBorderDarkerBg: '#b5d2fe',
  grayBorderDarkestBg: '#f2b1b8',
  grayBorderVeryLightBg: '#e9ecef',
  grayBorderVeryLighterBg: '#fae4a2',
  grayBorderVeryDarkBg: '#f9d8dc',
  grayBorderVeryDarkerBg: '#fcfcfd',
  grayBorderVeryDarkestBg: '#ced4da',
  grayBorderVeryLightestBg: '#e2e3e5',
  // Bootstrap CSS variables
  bsPrimaryTextEmphasis: '#036',
  bsSecondaryTextEmphasis: '#2b2f32',
  bsSuccessTextEmphasis: '#124f38',
  bsInfoTextEmphasis: '#1c3965',
  bsWarningTextEmphasis: '#614b09',
  bsDangerTextEmphasis: '#59181f',
  bsLightTextEmphasis: '#495057',
  bsDarkTextEmphasis: '#495057',
  bsPrimaryBgSubtle: '#cce6ff',
  bsSecondaryBgSubtle: '#e2e3e5',
  bsSuccessBgSubtle: '#d5f3e8',
  bsInfoBgSubtle: '#dae9fe',
  bsWarningBgSubtle: '#fcf2d0',
  bsDangerBgSubtle: '#f9d8dc',
  bsLightBgSubtle: '#fcfcfd',
  bsDarkBgSubtle: '#ced4da',
  bsPrimaryBorderSubtle: '#9cf',
  bsSecondaryBorderSubtle: '#c4c8cb',
  bsSuccessBorderSubtle: '#abe8d1',
  bsInfoBorderSubtle: '#b5d2fe',
  bsWarningBorderSubtle: '#fae4a2',
  bsDangerBorderSubtle: '#f2b1b8',
  bsLightBorderSubtle: '#e9ecef',
  bsDarkBorderSubtle: '#adb5bd',
  // Chart colors
  chartBlue: '#5470c6',
  chartGreen: '#91cc75',
  chartYellow: '#fac858',
  chartRed: '#ee6666',
  chartOrange: '#FF9800',
  chartPurple: '#9B02FD',
  chartCyan: '#00aeef',
  chartGray: '#737373',
  chartDarkGray: '#383838',
  chartLightGray: '#dcdcdc',
  chartVeryLightGray: '#f8f8f8',
  chartBlueLight: '#007bff',
  chartDark: '#1e1e1e',
  // Status colors
  statusOpen: '#f2bc16',
  statusPaid: '#f2bc16',
  statusClosed: '#df3c4e',
  statusUnpaid: '#df3c4e',
  statusOpenBg: '#fdf7e3',
  statusPaidBg: '#fdf7e3',
  statusClosedBg: '#fbe8ea',
  statusUnpaidBg: '#fbe8ea',
  // Progress bar colors
  progressGreen: '#4CAF50',
  progressYellow: '#FFC107',
  progressRed: '#F44336',
  // Switch colors
  switchWhite: '#ffffff',
  switchGray: '#E7EAEB',
  switchBorder: '#cbced2',
  switchGrayLight: '#e7eaeb',
  switchGrayMedium: '#9eacae',
  switchGrayDark: '#d2d4e4',
  switchTextDark: '#3c3f56',
  // Dropdown colors
  dropdownGray: '#787C9E',
  dropdownGrayLight: '#A1A3B5',
  dropdownGrayDark: '#000',
  dropdownBorder: '#d2d4e4',
  dropdownGrayVeryLight: '#f7f7f7',
  dropdownBlue: '#136acd',
  dropdownGrayMedium: '#666',
  dropdownBorderLight: '#ced4da',
  dropdownGrayLighter: '#f8f9fa',
  dropdownBorderMedium: '#dbe2e9',
  dropdownBorderDark: '#ced4da',
  // Factory colors
  factoryGray: '#383838',
  factoryGrayLight: '#dcdcdc',
  factoryGrayVeryLight: '#f8f8f8',
  factoryBlue: '#007bff',
  factoryDark: '#1e1e1e',
  factoryGreen: '#32c682',
  // Input tag colors
  inputTagBlue: '#080885',
  // Date range picker colors
  datePickerGray: '#737373',
  // Data table colors
  dataTableBlack: '#000',
  // Form signup colors
  formSignupPurple: '#9B02FD',
  spinnerBg: 'rgba(42, 44, 67, 0.4)',
  sidebarBg: 'rgb(9, 1, 39)',
}
